// Чтение полей строки OLAP iiko: поле приходит ключом с точкой («ProductCostBase.Profit») или вложенным объектом
// ({ ProductCostBase: { Profit } }). Пока используется ABC-анализом; «Себестоимость» переводится в своей задаче.

export function olapValue(row, field) {
  if (!row || typeof row !== 'object') return undefined;
  if (row[field] !== undefined && row[field] !== null) return row[field];
  return field.split('.').reduce((value, key) => (value === undefined || value === null ? undefined : value[key]), row);
}

// Число; нет поля, пусто или не число — 0
export function olapNumber(row, field) {
  const value = Number(olapValue(row, field));
  return Number.isFinite(value) ? value : 0;
}

// Строка как есть; нет поля — ''
export function olapText(row, field) {
  const value = olapValue(row, field);
  return value === undefined || value === null ? '' : String(value);
}
